var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.99593C2.00417 7.55719 2.18587 7.13772 2.50571 6.82842L6.18286 3.2425C6.34345 3.08718 6.5607 3 6.78714 3C7.01359 3 7.23083 3.08718 7.39143 3.2425C7.47177 3.32003 7.53553 3.41226 7.57905 3.51388C7.62257 3.61551 7.64497 3.72451 7.64497 3.8346C7.64497 3.94468 7.62257 4.05368 7.57905 4.15531C7.53553 4.25693 7.47177 4.34916 7.39143 4.42669L4.57143 7.16199H13.1429C13.3702 7.16199 13.5882 7.24985 13.7489 7.40625C13.9097 7.56264 14 7.77475 14 7.99593C14 8.2171 13.9097 8.42921 13.7489 8.58561C13.5882 8.742 13.3702 8.82986 13.1429 8.82986H4.57143L7.39143 11.5735C7.55283 11.7294 7.64396 11.9414 7.64476 12.1626C7.64557 12.3839 7.55598 12.5965 7.39571 12.7535C7.23545 12.9106 7.01763 12.9992 6.79017 13C6.56272 13.0008 6.34426 12.9136 6.18286 12.7577L2.50571 9.17177C2.18378 8.86042 2.00191 8.43756 2 7.99593Z",
    fill: "#63666A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowSmall);
export default __webpack_public_path__ + "static/media/backArrowSmall.85a0f9379efa215ca4388d5a6c6a3a5b.svg";
export { ForwardRef as ReactComponent };